import {
  AkaTravelCoverage,
  InsuranceCoverage,
} from "Store/interfaces/products/coverage";

import { BooleanFormType } from "Store/interfaces/FormTypes";
import { AkaTravelProductIntroFormValues } from "../ProductIntro/akaTravelProductIntroInterfaces";
import { AkaTravelProductPriceFormValues } from "./akaTravelProductPriceInterfaces";

export const getIsInsuranceForValue = (
  formState: AkaTravelProductIntroFormValues,
): boolean => formState?.isInsuranceFor === BooleanFormType.TRUE;

export const getCoverageToDisplay = (
  formState: AkaTravelProductIntroFormValues,
): InsuranceCoverage =>
  getIsInsuranceForValue(formState)
    ? AkaTravelCoverage.AKA_TRAVEL_FOR_INSURED_ONLY
    : AkaTravelCoverage.AKA_TRAVEL_FOR_FAMILY;

export const mapBetweenInsuredAndFamilyAkaTravelCoverage = (
  coverage: InsuranceCoverage,
): InsuranceCoverage => {
  switch (coverage) {
    case AkaTravelCoverage.AKA_TRAVEL_FOR_FAMILY:
      return AkaTravelCoverage.AKA_TRAVEL_FOR_INSURED_ONLY;
    case AkaTravelCoverage.AKA_TRAVEL_FOR_INSURED_ONLY:
      return AkaTravelCoverage.AKA_TRAVEL_FOR_FAMILY;
    default:
      return coverage;
  }
};

export const akaTravelCoverageMatchesFamilyOrInsuredOnlyStatus = (
  forInsuredOnly: boolean,
  coverage: InsuranceCoverage,
): boolean => {
  if (forInsuredOnly) {
    return coverage === AkaTravelCoverage.AKA_TRAVEL_FOR_INSURED_ONLY;
  }
  return coverage === AkaTravelCoverage.AKA_TRAVEL_FOR_FAMILY;
};

export const getInitialFormStateWithCorrectedAkaTravelCoverage = (
  formState: AkaTravelProductPriceFormValues,
  forInsuredOnly: boolean,
): AkaTravelProductPriceFormValues => {
  if (
    akaTravelCoverageMatchesFamilyOrInsuredOnlyStatus(
      forInsuredOnly,
      formState.coverage,
    )
  ) {
    return formState;
  }
  return {
    ...formState,
    coverage: mapBetweenInsuredAndFamilyAkaTravelCoverage(formState.coverage),
  };
};
